export const MAIA_HOME_URL = 'https://okmaia.com/mentor-ia';
export const MAIA_MARKDOWN_URL = 'https://okmaia.com/mentor-ia.md';

export const COMPANY_HOME_URL = 'https://okmaia.com/';
export const COMPANY_MARKDOWN_URL = 'https://okmaia.com/index.md';

export const WHATSAPP_LANDING_URL = 'https://okmaia.com/agente-ia-whatsapp';
export const WHATSAPP_LANDING_MARKDOWN_URL = 'https://okmaia.com/agente-ia-whatsapp.md';

export const ARTICLES_URL = 'https://okmaia.com/artigos';
export const ARTICLES_MARKDOWN_URL = 'https://okmaia.com/artigos.md';

export const PANEL_URL = 'https://okmaia.com';
export const PANEL_LOGIN_URL = `${PANEL_URL}/login`;
export const PANEL_REGISTER_URL = `${PANEL_URL}/register`;
export const PANEL_LEAD_URL = `${PANEL_URL}/lead`;
export const PANEL_PRIVACY_URL = `${PANEL_URL}/privacidade`;
export const PANEL_TERMS_URL = `${PANEL_URL}/termos`;
